import get from 'lodash.get';
import { priceApiTransformer } from '../../../checkout/api/checkout.tranformer';
import { IPriceData } from '../../../checkout/types/checkout.types';
import { getPercentageDiff } from '../p/utils';
import { TPriceDetails } from './pricingTypes';

export const transformPriceDetails = (
  pricingPlans: Array<Partial<TPriceDetails>>
): TPriceDetails => {
  const originalPrice = get(
    pricingPlans,
    ['0', 'planDetails', 'offerPricing', 'originalPrice'],
    0
  );
  const totalAmount = get(
    pricingPlans,
    ['0', 'planDetails', 'pricing', 'totalAmount'],
    0
  );
  const tax = get(pricingPlans, ['0', 'planDetails', 'pricing', 'tax'], 0);
  return {
    externalId: get(pricingPlans, ['0', 'externalId'], ''),
    planName: get(pricingPlans, ['0', 'planDetails.name'], ''),
    originalPrice: Math.floor(originalPrice),
    totalAmount: Math.floor(totalAmount),
    discountPercentage: getPercentageDiff(originalPrice, totalAmount),
    tax: Math.floor(tax),
    listPrice: Math.floor(get(pricingPlans, ['0', 'planDetails', 'price'], 0)),
    servicesIncluded: get(
      pricingPlans,
      ['0', 'planDetails', 'servicesIncluded'],
      []
    ),
  };
};

export const transformPricingToObj = (
  pricingPlans: Array<IPriceData>
): Record<string, IPriceData> => {
  if (pricingPlans && pricingPlans.length) {
    return pricingPlans.reduce((sum, ele) => {
      const couponCode = get(ele, 'autoApplicableCoupon.code', '');
      const couponDiscount = get(ele, 'autoApplicableCoupon.discountValue', '');
      const planDetails = get(ele, 'planDetails', {});
      const pricing = get(ele, 'planDetails.pricing', {});
      return {
        ...sum,
        [String(ele.externalId)]: priceApiTransformer({
          ...planDetails,
          ...pricing,
          couponDiscount,
          couponCode,
        }),
      };
    }, {});
  }
  return {};
};

export const transformPricingToObjWName = (
  pricingPlans: Array<TPriceDetails>
): Record<string, TPriceDetails> => {
  if (pricingPlans && pricingPlans.length) {
    return pricingPlans.reduce((sum, ele) => {
      return {
        ...sum,
        [String(ele.externalId)]: {
          externalId: get(ele, 'externalId', ''),
          originalPrice: get(ele, 'planDetails.offerPricing.originalPrice', ''),
          totalAmount: get(ele, 'planDetails.pricing.totalAmount', ''),
          discountPercentage: get(
            ele,
            'planDetails.offerPricing.discountPercentage',
            ''
          ),
          tax: get(ele, 'planDetails.pricing.tax', ''),
          planName: get(ele, 'planDetails.name', ''),
          listPrice: get(ele, 'planDetails.price', 0),
        },
      };
    }, {});
  }
  return {};
};
